import { sortedAmounts } from './priceRuleFormat'
import { Trend, changedClass } from '../../scheduleCard/scheduleParts'

import { PriceRule } from '../../../../../types/booking/booking'
import { formatMinutes, formatMoney } from '../../../../../utils/booking/booking'

/**
 * One pill per session length (compact: smaller pills). Against the version this one replaced, a changed price is
 * highlighted with an up or down arrow; a newly added length is highlighted without one.
 */
export const RulePrices = ({ rule, previous, compact = false }: { rule: PriceRule; previous?: PriceRule; compact?: boolean }) => (
  <div className={compact ? 'schedule-card-chips' : 'schedule-card-prices'}>
    {sortedAmounts(rule).map(amount => {
      const before = previous?.amounts.find(other => other.durationMinutes === amount.durationMinutes)
      const changed = previous !== undefined && before?.amount !== amount.amount
      const trend = <Trend value={amount.amount} before={before?.amount} />

      if (compact) {
        return (
          <span key={amount.durationMinutes} className={`schedule-card-price-pill${changedClass(changed)}`}>
            <span className="schedule-card-duration">{formatMinutes(amount.durationMinutes)}</span>
            <span className="mono fw-semibold">{formatMoney(amount.amount, rule.currency)}</span>
            {trend}
          </span>
        )
      }

      return (
        <div key={amount.durationMinutes} className={`schedule-card-price${changedClass(changed)}`}>
          <span className="schedule-card-duration">{formatMinutes(amount.durationMinutes)}</span>
          <span className="schedule-card-divider" aria-hidden="true">/</span>
          <span className="mono schedule-card-amount">{formatMoney(amount.amount, rule.currency)}</span>
          {trend}
        </div>
      )
    })}
  </div>
)
